import { Checkbox } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import TableHeaderCell from '../../../../../components/TableElements/TableHeaderCell'
import { useNewHeadCheckbox } from '../hooks/useNewHeadCheckbox'

type NewHeadCheckboxProps = {
  firstStatus: number
  data: any
  checkboxStore: any
}

const NewHeadCheckbox: FC<NewHeadCheckboxProps> = ({
  firstStatus,
  data,
  checkboxStore,
}) => {
  const {
    isAllChecked,
    isIndeterminate,
    onHeadCheckboxClick,
    isHeadCheckboxDisabled,
  } = useNewHeadCheckbox(firstStatus, data, checkboxStore)

  return (
    <TableHeaderCell
      key='header-checkbox'
      width='4%!important'
      propKey='checkbox'
      customPadding='8px'
    >
      <Checkbox
        checked={isAllChecked}
        indeterminate={isIndeterminate}
        disabled={isHeadCheckboxDisabled}
        onChange={onHeadCheckboxClick}
      />
    </TableHeaderCell>
  )
}

export default observer(NewHeadCheckbox)
